export const getLocalStorageCardExpandedProp = name => LocalStorage.get(name);

export const setLocalStorageCardExpandedProp = (name, value) => LocalStorage.set(name, value);
import { useState, useEffect } from 'react';
import { parse } from 'query-string';
import { updateLocation, LocalStorage } from '../../utils/utils';

export const useCardNavTabsWithRoutes = ({tabKeys, active = 1, history}) => {
  const [activeTab, setActiveTab] = useState(active);

  const handleTabChange = tab => {
    Object.keys(tabKeys).forEach(key => {
      if(tabKeys[key] === tab) {
        updateLocation({tab: key});
      }
    });
  };

  useEffect(() => {
    const { tab } = parse(history.location.search);
    const tabKey = tabKeys[tab];
    if(tabKey) {
      setActiveTab(tabKey);
    } else {
      setActiveTab(1);
    }
  }, []);

  return {
    activeTab,
    handleTabChange,
  };
};
